import React, { memo } from 'react'
import moment from 'moment'
import { TableRow } from '@mui/material'

import Text from '../shared/text/Text'
import BaseCard from '../shared/baseCard/BaseCard'
import DataTable from '../shared/DataTable/DataTable'
import { formatEthCurrency } from '../../util/numbers.helpers'
import { truncateTextForHash } from '../../util/app.helpers'
import BadgeColumn from '../shared/DataTable/BadgeColumn'
import TableCellData from '../shared/DataTable/TableCellData'
import CustomTooltip from '../shared/customTooltip/CustomTooltip'

const RecentDeposits = ({ t, timeline }) => {
  const headers = [
    '',
    t('leaderboard.wallet'),
    t('leaderboard.deposit'),
    t('leaderboard.time')
  ]
  return (
    <BaseCard>
      <Text
        variant='h2'
        label={t('home.most-recent-deposits')}
        fontWeight={700}
        sx={{ mb: 2 }}
      />
      <DataTable
        headers={headers.map((header) => ({ label: header }))}
        data={timeline.map((props, index) => (
          <DataTableRow key={index} {...props} />
        ))}
        size='small'
      />
    </BaseCard>
  )
}

export default memo(RecentDeposits)

const DataTableRow = ({ fromAddress, amount, inserted_at }) => {
  return (
    <TableRow>
      <BadgeColumn
        badge={fromAddress.slice(-2)}
        sx={{
          backgroundColor: 'primary.main',
          width: 30,
          height: 30,
          fontSize: '0.9rem'
        }}
        tableCellSx={{
          pb: 0,
          pt: 0
        }}
      />
      <TableCellData>
        <CustomTooltip label={fromAddress}>
          {truncateTextForHash(fromAddress)}
        </CustomTooltip>
      </TableCellData>
      <TableCellData>{formatEthCurrency(amount, 4)}</TableCellData>
      <TableCellData>{moment.utc(inserted_at).fromNow()}</TableCellData>
    </TableRow>
  )
}
